// config.js
declare var lendio: {
  environment: string;
  API_URL: string;
  AVATAR_BASE_URL: string;
  BP_API_URL: string;
  PIPELINE_BASE_URL: string;
  PUSHER_APP_KEY: string;
  ROLLBAR_API_TOKEN: string;
  TENANT_CREDIT_BUTTON_DISABLE: boolean;
  oktaClientId: string;
  signOutRedirectUrl: string;
  useSingleSignOn: boolean;
  autoBccEmails: string;
  DATADOG_APPLICATION_ID: string;
  DATADOG_CLIENT_TOKEN: string;
  locale: string;
  BANK_CONNECTION_URL: string;
}

// commit.js
declare var GIT_COMMIT: string;

export const environment = Object.assign({}, lendio, {
  production: lendio.environment === 'LIVE',
  GIT_COMMIT
});
